import { render, staticRenderFns } from "./ManpowerLabour.vue?vue&type=template&id=079e4c77&"
import script from "./ManpowerLabour.vue?vue&type=script&lang=js&"
export * from "./ManpowerLabour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports